
import img_ejemplo_dom_fiscal from '../assets/ejemplo_dom_fiscal.jpeg';

const ModalDomicilioFiscal = () => {
    return (
        <>

            {/* imagen domicilio fiscal */}
            <div style={{cursor: 'pointer'}} className="mb-3 d-flex justify-content-center alert alert-primary">
                {/* <label className='link-primary' >Obtener Domicilio Fiscal</label> <label>(Datos del domicilio registrado)</label><br/> */}
                <div className='d-flex flex-column align-items-center'>
                    <label className='mb-3'>Click en la imagen para ver ejemplo del domicilio fiscal.</label>
                    <img src={img_ejemplo_dom_fiscal} width="150" alt='Ejemplo de domicilio fiscal' data-bs-toggle="modal" data-bs-target="#modal_domicilio_fiscal"/><br/>
                </div>
            </div>

            {/* modal domicilio fiscal */}
            <div className="modal fade" id="modal_domicilio_fiscal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                    <div className="modal-body">
                        <div className="alert alert-primary d-flex align-items-center" role="alert">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-info-circle" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                            <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                        </svg>
                        <div className="pt-2">
                            &nbsp;<label className='h6'>Obtener Domicilio Fiscal:&nbsp;</label>
                            <label>Los datos se encuentran en la sección Datos del domicilio registrado</label>
                        </div>
                        </div>
                        <img src={img_ejemplo_dom_fiscal} width="100%" alt='Ejemplo de domicilio fiscal'/>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                    </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ModalDomicilioFiscal
